import { makeStyles } from '@material-ui/core';

import { COLOR_TONE } from '../../../../shared/styles/colors';

export default makeStyles(() => ({
  dropDownContainer: {
    backgroundColor: COLOR_TONE.gray.A10,
  },
  dropDownInfoTitle: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  dropDownInfoDescription: {
    fontSize: '0.75rem',
    fontWeight: 400,
  },
  divider: {
    height: '1px',
    width: '100%',
    border: `1px solid ${COLOR_TONE.gray['20']}`,
  },
  banner: {
    fontSize: '0.75rem',
    borderRadius: '0.5rem',
    lineHeight: 1.7,
    color: COLOR_TONE.blue['70'],
    backgroundColor: COLOR_TONE.blue['10'],
    '& > .MuiAlert-icon': {
      color: COLOR_TONE.blue['70'],
    },
    '& a': {
      fontWeight: 600,
    },
  },
  dropDownActionContentBtnRoot: {
    cursor: 'pointer',
    '&:disabled': {
      color: COLOR_TONE.gray['30'],
      fill: COLOR_TONE.gray['30'],
    },
  },
  dropDownActionContentBtnContainer: {
    columnGap: '1rem',
    textAlign: 'left',
    '& > :nth-child(odd)': {
      margin: 0,
    },
  },
  dropDownActionTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
  },
  dropDownActionDescription: {
    fontSize: '0.625rem',
    fontWeight: 400,
  },
  dropDownIcon: {
    width: '1.25rem',
    height: '1.25rem',
    fill: '#5800DC',
  },
  button: {
    padding: '0.5rem 0.75rem',
    fontFamily: 'inherit',
    fontWeight: 600,
    fontSize: '0.875rem',
    lineHeight: '1.5rem',
    borderRadius: '0.5rem',
    color: COLOR_TONE.neutral['100'],
    border: `1px solid ${COLOR_TONE.neutral['20']}`,
    backgroundColor: COLOR_TONE.neutral.white,
  },
  buttonStartIconAnimation: {},
  buttonStartIcon: {},
  buttonEndIcon: ({ isDropDownOpen = false }: Props) => ({
    transform: isDropDownOpen ? 'rotateX(180deg)' : '',
  }),
  popoverPaper: {
    maxWidth: '24rem',
    borderRadius: '0.5rem',
    border: `1px solid ${COLOR_TONE.neutral['20']}`,
  },
  drawerPaper: {
    backgroundColor: COLOR_TONE.gray.A10,
  },
  drawerCloseBtn: {
    margin: '0 0 1rem',
    padding: '1.125rem',
    fontSize: '1rem',
    lineHeight: 1.25,
    color: COLOR_TONE.red['40'],
    backgroundColor: COLOR_TONE.gray['0'],
  },
}));

interface Props {
  isDropDownOpen?: boolean;
}
